module.exports = "pegasus/assets/themelp1/small/5.png";